import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { SimulationService } from "@services/simulation.service";
import { Simulation } from "@classes/simulation/simulation";

@Injectable()
export class SimulationResolver implements Resolve<Simulation> {
    constructor(
        private simuSrv: SimulationService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Simulation> {
        const localSimu = this.simuSrv.localSimu;

        if(localSimu) {
            return of(localSimu);
        }

        return this.simuSrv.get()
        .pipe(
            catchError((err) => {
                return of(null);
            })
        );
    }
}
